import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { GetCoveragesFailure, GetCoveragesRequest, GetCoveragesSuccess } from './actions';
import { Coverage } from '@models/swagger';

export const featureKey = 'getCoverages';

export interface State {
  data: Coverage[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(GetCoveragesFailure, (state, { error }) => ({ ...state, data: [], error, loading: false })),
    on(GetCoveragesRequest, state => ({ ...state, error: null, loading: true })),
    on(GetCoveragesSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
